import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Label } from 'react-bootstrap';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import Layout from '../../components/layout/Layout';
import BuildingCard from '../../components/buildingcard/BuildingCard';
import BuildingCreateModal from '../../modal/buildings/BuildingCreateModal';
import Card from '../../components/card/Card';
import Alert from '../../modal/alert/Alert';
import ProjectEditModal from '../../modal/projects/ProjectEditModal';
import ProjectComponent from '../../components/project_detail/BuildingComponent';
import ProjectUploadImageModal from '../../modal/projects/ProjectUploadImage';
import ProjectBasicInfo from '../../components/project_detail/ProjectBasicInfo';
import ProjectSubmissionModal from '../../modal/project_submission/ProjectSubmissionModal';
import SubmissionCommentModal from '../../modal/project_submission/SubmissionCommentModal';
import MemberInvitationModal from '../../modal/member/MemberInvitationModal';
import ImagePreviewSlider from '../../components/project_detail/ImagePreviewSlider';
import MixedUseProjectComponent from '../../components/project_detail/MixedUseProjectComponent';
import {
  SystemEvaluationResult,
  EnergyEvaluationResult,
  EvaluationResultDetail,
} from '../../components/evaluation/EvaluationResult';

import {
  defaultRejectHandler,
  getErrorValue,
  createPdf,
} from '../../utils/utility';
import { convertProject } from '../../utils/converter';

import {
  getProject,
  deleteProject,
  clearErrorProject,
  exportReport,
} from '../../redux/projects/projects_actions';

import {
  listProjectInspectionByProject,
  revokeProjectSubmission,
} from '../../redux/project_inspection/project_inspection_actions';

import '../../components/default.css';
import ErrorModal from '../../modal/util/ErrorModal';
import LoadingModal from '../../modal/util/LoadingModal';

class MixedUseProjectDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: this.props.match.params.projectId,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowCreateBuildingModal: false,
      isShowUploadImageModal: false,
      isShowProjectSubmissionModal: false,
      isShowRevokeSubmissionModal: false,
      isShowCommentModal: false,
      isShowInviteMemberModal: false,
      isShowErrorModal: false,
      isShowEvaluationWarningModal: false,
      isCreated: false,
      isCalcExporting: false,
      errorMessage: undefined,
    };

    this.defaultStatus = 'unset';

    this.statusMapper = {
      unset: 'status-pending',
      failed: 'status-failed',
      passed: 'status-passed',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.deleting !== nextProps.deleting && !nextProps.deleting && !nextProps.project) {
      nextProps.history.push('/projects/');
    }

    if (!nextProps.isSubmissionDeleting && nextProps.isSubmissionDeleting !== this.props.isSubmissionDeleting && !nextProps.submissionErrorMessage) {
      this.setState({ isShowProjectSubmissionModal: false });
      this.props.getProject(this.state.projectId);
    }

    if (!nextProps.isSubmissionSubmitting && nextProps.isSubmissionSubmitting !== this.props.isSubmissionSubmitting && !nextProps.submissionErrorMessage) {
      this.setState({ isShowProjectSubmissionModal: false });
      this.props.getProject(this.state.projectId);
    }

    if (!nextProps.isSubmissionRevoking && nextProps.isSubmissionRevoking !== this.props.isSubmissionRevoking && !nextProps.submissionErrorMessage) {
      this.setState({ isShowRevokeSubmissionModal: false });
      this.props.getProject(this.state.projectId);
    }
    
    if(nextProps.exportReportErrorMessage !== this.props.exportReportErrorMessage && nextProps.exportReportErrorMessage){
      this.setState({ isShowErrorModal: true, isCalcExporting: false });
    }
    if (this.props.isCreatingBuilding && nextProps.isCreatingBuilding !== this.props.isCreatingBuilding && !nextProps.exportReportErrorMessage) {
      this.setState({ isShowCreateBuildingModal: false, isCreated: true  });
    }
  }

  componentDidMount() {
    this.props.getProject(this.state.projectId);
    this.props.listSubmission(this.state.projectId);
    navigator.serviceWorker.onmessage = event => {
      switch (event.data.status) {
        case 'processing':
          this.setState({ isCalcExporting: true });
          break;
        case 'finished':
          this.setState({ isCalcExporting: false });
          event.data.url && createPdf(event.data.url);
          break;
        case 'error':
          this.setState({
            isCalcExporting: false,
            errorMessage: { detail: event.data.msg },
            isShowErrorModal: true,
          });
          break;
      }
    }
  }

  dismissErrorModal() {
    this.props.clearError();
    this.setState({ isShowErrorModal: false });
  }
  
  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissCreateBuildingModal() {
    this.props.clearError();
    this.setState({ isShowCreateBuildingModal: false });
  }

  dismissUploadImageModal() {
    this.props.clearError();
    this.setState({ isShowUploadImageModal: false });
  }

  dismissProjectSubmissionModal() {
    this.props.clearError();
    this.setState({ isShowProjectSubmissionModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissRevokeModal() {
    this.props.clearError();
    this.setState({ isShowRevokeSubmissionModal: false });
  }

  dismissCommentModal() {
    this.props.clearError();
    this.setState({ isShowCommentModal: false });
  }

  dismissInviteMemberModal() {
    this.props.clearError();
    this.setState({ isShowInviteMemberModal: false });
  }

  dismissEvaluationWarningModal() {
    this.setState({ isShowEvaluationWarningModal: false });
  }

  handleSubmitClick() {
    const { project } = this.props;
    if (project &&
      project.evaluation.evaluation_all_system !== 'passed' &&
      project.evaluation.evaluation_energy_consumption !== 'passed') {
      this.setState({ isShowEvaluationWarningModal: true });
    } else {
      this.setState({ isShowProjectSubmissionModal: true });
    }
  }

  getEvaluationWarningTitle() {
    const { i18n } = this.props;
    const lang = i18n.language.split('-')[0];
    
    if (lang === 'th') {
      return 'ไม่สามารถส่งโครงการได้';
    }
    return 'Cannot Submit';
  }

  getEvaluationWarningMessage() {
    const { i18n } = this.props;
    const lang = i18n.language.split('-')[0];
    
    if (lang === 'th') {
      return 'เนื่องจากผลการประเมินระบบอาคาร (Evaluation All System) และผลการประเมินการใช้พลังงาน (Energy Consumption) ยังไม่ผ่านเกณฑ์';
    }
    return 'Both System Evaluation (Evaluation All System) and Energy Consumption Evaluation have not passed the criteria.';
  }

  navigateBuildingDetail(building) {
    this.props.history.push(`/buildings/${building.id}`);
  }

  renderActionMenu() {
    const { submission, isSubmissionLoading, project, t } = this.props;

    const normalMenuSet = new Set([
      'project-edit-menu',
      'project-delete-menu',
      'project-create-building-menu',
      'project-submit-menu',
      'project-upload-image-menu',
      'project-export-report-menu',
      'project-member',
    ]);

    const submittedMenuSet = new Set([
      'project-revoke-submission-menu',
      'project-export-report-menu',
      'project-submission-comment',
    ]);

    const rejectedMenuSet = new Set([
      'project-edit-menu',
      'project-delete-menu',
      'project-create-building-menu',
      'project-submit-menu',
      'project-upload-image-menu',
      'project-export-report-menu',
      'project-submission-comment',
    ]);

    let availableMenuSet = normalMenuSet;
    if (submission && submission.status) {
      switch (submission.status) {
        case Constants.PROJECT_SUBMISSION.SUBMITTED:
          availableMenuSet = submittedMenuSet;
          break;
        case Constants.PROJECT_SUBMISSION.REJECTED:
          availableMenuSet = rejectedMenuSet;
          break;
        default:
          availableMenuSet = normalMenuSet;
      }
    }

    if (project && !project.is_owner) {
      availableMenuSet.delete('project-submit-menu');
      availableMenuSet.delete('project-edit-menu');
      availableMenuSet.delete('project-delete-menu');
      availableMenuSet.delete('project-revoke-submission-menu');
      availableMenuSet.delete('project-submission-comment');
    }

    return [
      <li key="project-edit-menu">
        <a
          href="#"
          id="project-edit"
          onClick={() => this.setState({ isShowEditModal: true })}
        >
          <i className="fas fa-edit" /><span className="menu-text">{t('edit project')}</span>
        </a>
      </li>,
      <li key="project-delete-menu">
        <a
          href="#"
          id="project-delete"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" /><span className="menu-text">{t('delete project')}</span>
        </a>
      </li>,
      <li key="project-create-building-menu">
        <a
          href="#"
          id="project-create-building"
          onClick={() => this.setState({ isShowCreateBuildingModal: true, isCreated: false })}
        >
          <i className="fas fa-building" /><span className="menu-text">{t('create building')}</span>
        </a>
      </li>,
      <li key="project-upload-image-menu">
        <a
          href="#"
          id="project-upload-image"
          onClick={() => this.setState({ isShowUploadImageModal: true })}
        >
          <i className="fas fa-paperclip" /><span className="menu-text">{t('upload image')}</span>
        </a>
      </li>,
      <li key="project-export-report-menu">
        <a
          href="#"
          id="project-export-report"
          onClick={() => !this.props.isCalcExporting && this.props.exportReport(this.state.projectId) && this.setState({ isCalcExporting: true })}
        >
          <i className="fas fas fa-file-download" /><span className="menu-text">{t('calculation report')}</span>
        </a>
      </li>,
      <li key="project-submit-menu">
        <a
          href="#"
          id="project-submit"
          onClick={() => this.handleSubmitClick()}
        >
          <i className="fas fa-paper-plane" /><span className="menu-text">{t('submit project')}</span>
        </a>
      </li>,
      <li key="project-revoke-submission-menu">
        <a
          href="#"
          id="project-revoke-submission"
          onClick={() => this.setState({ isShowRevokeSubmissionModal: true })}
        >
          <i className="far fa-times-circle" /><span className="menu-text">{t('revoke project submission')}</span>
        </a>
      </li>,
      <li key="project-submission-comment">
        <a
          href="#"
          id="project-comment"
          onClick={() => this.setState({ isShowCommentModal: true })}
        >
          <i className="fas fa-comment-alt" /><span className="menu-text">{t('comment submission')}</span>
        </a>
      </li>,
      <li key="project-member">
        <a
          href="#"
          id="project-member"
          onClick={() => this.setState({ isShowInviteMemberModal: true })}
        >
          <i className="fas fa-users" /><span className="menu-text">{t('members')}</span>
        </a>
      </li>,
    ].filter(element => !isSubmissionLoading && availableMenuSet.has(element.key));
  }

  renderEvaluationStatus(status) {
    const { t } = this.props;
    return (
      <span style={{ fontWeight: "bold" }}>
        {t("overall")}:
        <span className={'project-status-text ' + this.statusMapper[status]}>
          {" " + t(status.toLowerCase()).toUpperCase()}
        </span>
      </span>
    );
  }

  renderEvaluation(building) {
    const {
      name,
      evaluation,
    } = building;
    const { t, i18n } = this.props;

    const {
      evaluation_all_system,
      evaluation_energy_consumption,
    } = evaluation;
    const key = `building_type_name_${i18n.language.split('-').pop()}`;
    return [
      <Row>
        <h3>
          {name} <Label>{building[key]}</Label>
        </h3>
      </Row>,
      <Row>
        <Col xs={12} sm={12} md={6}>
          <Card
            header={t('evaluation 1')}
            footer={this.renderEvaluationStatus(evaluation_all_system)}
          >
            <SystemEvaluationResult evaluation={evaluation} t={t} />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Card
            header={t('evaluation 2')}
            footer={this.renderEvaluationStatus(evaluation_energy_consumption)}
          >
            <EnergyEvaluationResult evaluation={evaluation} t={t} />
            <div style={{ height: '105px' }} />
          </Card>
        </Col>
      </Row>,
      <Row>
        <Col xs={12} sm={12} md={12}>
          <Card header={t('evaluation detail')}>
            <EvaluationResultDetail evaluation={evaluation} t={t} />
          </Card>
        </Col>
      </Row>,
    ];
  }

  renderProject(project) {
    const { submission, errorMessage, t } = this.props;
    const { images, buildings } = project;

    return (
      <Grid>
        <Row>
          <div className="nonewline-group" style={{ minWidth: '100%' }}>
            {project.buildings
              ? project.buildings.map((building, index) => (
                  <Col xs={12} sm={6} md={4} lg={3} key={index}>
                    <BuildingCard
                      building={convertProject(building)}
                      onClick={() => this.navigateBuildingDetail(building)}
                    />
                  </Col>
                ))
              : null}
          </div>
        </Row>
        <Row className="show-grid">
          <LoadingModal
            show={this.props.isSummaryExporting || this.state.isCalcExporting}
          />
          <ErrorModal 
            show={this.state.isShowErrorModal}
            errorMessage={this.props.exportReportErrorMessage || this.state.errorMessage}
            onHide={()=> this.dismissErrorModal()}
          />
          <Col xs={12} sm={12} md={6}>
            <Card className="project-summary">
              <ProjectBasicInfo project={convertProject(project)} />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6}>
            <Card padding={false}>
              <ImagePreviewSlider images={images} />
            </Card>
          </Col>
        </Row>
        {buildings.map(building => this.renderEvaluation(building))}

        <Row>
          <Col xs={12}>
            <Card header={t('components')}>
              <MixedUseProjectComponent project={project} />
            </Card>
          </Col>
        </Row>

        <BuildingCreateModal
          show={this.state.isShowCreateBuildingModal}
          isCreated = {this.state.isCreated}
          onHide={() => this.dismissCreateBuildingModal()}
          project={project}
        />
        <ProjectEditModal
          project={project}
          show={this.state.isShowEditModal}
          onHide={() => this.dismissEditModal()}
        />
        <ProjectUploadImageModal
          project={project}
          show={this.state.isShowUploadImageModal}
          onHide={() => this.dismissUploadImageModal()}
        />
        <ProjectSubmissionModal
          submissionDetail={submission && submission.status === Constants.PROJECT_SUBMISSION.DRAFT ? submission : undefined}
          project={project}
          show={this.state.isShowProjectSubmissionModal}
          onHide={() => this.dismissProjectSubmissionModal()}
        />
        <SubmissionCommentModal
          submission={submission}
          show={this.state.isShowCommentModal}
          onHide={() => !this.props.isCommentCreating && this.dismissCommentModal()}
        />
        <MemberInvitationModal
          project={project}
          show={this.state.isShowInviteMemberModal}
          onHide={() => this.dismissInviteMemberModal()} />
        <Alert
          show={this.state.isShowDeleteModal}
          onHide={() => !this.props.deleting && this.dismissDeleteModal()}
          title={t('delete project')}
          body={`${t('do you want to delete')} ${project.name}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={this.props.deleting ? t('deleting') : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!this.props.deleting}
          onPrimaryButtonClick={() => this.props.deleteProject(project.id)}
        />
        <Alert
          show={this.state.isShowRevokeSubmissionModal}
          onHide={() => !this.props.isSubmissionRevoking && this.dismissRevokeModal()}
          title={t('revoke project submission')}
          body={`${t('do you want to revoke project submission')} ${project.name}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={this.props.isSubmissionRevoking ? t('revoking') : t('revoke')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!this.props.isSubmissionRevoking}
          onPrimaryButtonClick={() => this.props.revokeSubmission(submission.id)}
        />
        <Alert
          show={this.state.isShowEvaluationWarningModal}
          onHide={() => this.dismissEvaluationWarningModal()}
          title={this.getEvaluationWarningTitle()}
          body={this.getEvaluationWarningMessage()}
          primaryButtonTitle={t('ok')}
          primaryButtonStyle="primary"
          onPrimaryButtonClick={() => this.dismissEvaluationWarningModal()}
        />
      </Grid>
    );
  }

  render() {
    const { project, t } = this.props;
    const projectName = project ? project.name : 'ProjectName';
    const breadcrumbItems = [
      { name: t('projects'), path: '/projects' },
      { name: `${projectName || this.projectId}`, path: '/id' },
    ];

    let body;
    if (this.props.loading && (project && !project.hasOwnProperty('buildings'))) {
      body = <span>{t('loading')}</span>;
    } else if (project && project.hasOwnProperty('buildings')) {
      body = this.renderProject(project);
    } else {
      body = <h4>{t('project not found')}</h4>;
    }

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_project_detail.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        {body}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  loading: state.project.loading,
  deleting: state.project.deleting,
  project: state.project.objects[ownProps.match.params.projectId],
  isCalcExporting: state.project.exporting,
  exportReportErrorMessage: state.project.errorMessage,
  submission: state.projectInspection.orderedIds
    .sort((a, b) => b.id - a.id)
    .map(id => state.projectInspection.objects[id])
    .filter(({ project_id }) => project_id === parseInt(ownProps.match.params.projectId))
    .shift(),
  isSubmissionLoading: state.projectInspection.isCalcExporting,
  isSubmissionDeleting: state.projectInspection.isDeleting,
  isSubmissionSubmitting: state.projectInspection.isSubmitting,
  isSubmissionRevoking: state.projectInspection.isRevoking,
  submissionErrorMessage: state.projectInspection.errorMessage,
  isCreatingBuilding: state.project.creating_building,
});

const mapDispatchToProps = dispatch => ({
  getProject: id => defaultRejectHandler(dispatch(getProject(id))),
  deleteProject: id => defaultRejectHandler(dispatch(deleteProject(id))),
  exportReport: id => defaultRejectHandler(dispatch(exportReport(id))),
  clearError: () => dispatch(clearErrorProject()),
  listSubmission: projectId => defaultRejectHandler(dispatch(listProjectInspectionByProject(-1, 0, [{ id: 'id', desc: true }], null, projectId))),
  revokeSubmission: id => defaultRejectHandler(dispatch(revokeProjectSubmission(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MixedUseProjectDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/mixed_use_project_detail/MixedUseProjectDetailPage.js